<template>
    <TabBasic :key="$route.name" ref="tabBasic" :actual-breadcrumb="breadcrumb" :items="items" replace-route
              show-breadcrumbs @refreshPage="refreshCounter++">
        <slot>
            <AddEditZone ref="addEditZone"/>
        </slot>
    </TabBasic>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import AddEditZone from "@/components/Zones/AddEditZone";

export default {
  name: "ZoneEditBasic",
  components: {AddEditZone, TabBasic},
  provide() {
    const zoneInjection = {};
    Object.defineProperty(zoneInjection, 'zone', {
      enumerable: true,
      get: () => this.zone,
    });
    return {zoneInjection, refreshZone: this.initZone};
  },
  mounted() {
    if (this.isEdit) {
      this.initZone();
    }
  },
  data() {
    return {
      openNameDialog: this.$route.name === 'addZone',
      zoneName: '',
      zone: {},
      loading: false,
      loadingData: false,
      refreshCounter: 0,
      hasChanges: false,
    };
  },
  watch: {
    isEdit(val) {
      if (val) {
        this.initZone();
      }
    }
  },
  computed: {
    breadcrumb() {
      if (this.isEdit) {
        let breadcrumb = [];
        if (this.zone && this.zone.Name) {
          breadcrumb += this.zone.Name;
        }
        if (this.$route.name === 'zoneManagement') {
          breadcrumb += ' - ' + this.$t('zones.management');
        } else if (this.$route.name === 'geofenceHistory') {
          breadcrumb += ' - ' + this.$t('zones.geofenceHistory');
        } else {
          breadcrumb += ' - ' + this.$t('tooltips.edit');
        }
        return [{
          text: breadcrumb,
          disabled: false,
        }];
      }
      return null;
    },
    isEdit() {
      return ['editZone', 'zoneManagement', 'geofenceHistory'].includes(this.$route.name);
    },
    items() {
      if (!this.isEdit) {
        return [];
      }
      return [
        {
          title: this.$t('zone'),
          to: {
            name: 'editZone',
            params: {
              id: this.$route.params.id
            }
          }
        },
        {
          title: this.$t('zones.zoneManagement'),
          to: {
            name: 'zoneManagement',
            params: {
              id: this.$route.params.id
            }
          }
        },
        {
          title: this.$t('zones.geofenceHistory'),
          to: {
            name: 'geofenceHistory',
            params: {
              id: this.$route.params.id
            }
          }
        }
      ];
    }
  },
  methods: {
    saveZoneName(name) {
      this.zoneName = name;
      this.openNameDialog = false;
    },
    editText() {
      this.openNameDialog = true;
      alert('asd');
    },
    close() {
      if (this.zoneName) {
        this.openNameDialog = false;
      } else {
        this.$router.back();
      }
    },
    hasChangesStatus(status) {
      this.hasChanges = status;
    },
    saveZone(data) {
      let url = this.$store.getters.zones;
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store.dispatch('setLoader', true);
      if (this.isEdit) {
        url = this.$store.getters.zone(this.$route.params.id);
        this.axios.patch(url, data).then(() => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.zoneWasUpdated'),
          });
          this.initZone();
        }).finally(() => {
          this.loading = false;
          this.$store.dispatch('setLoader', false);
        });
      } else {
        this.axios.post(url, data).then(({data}) => {
          this.$router.replace({name: 'editZone', params: {id: data.Result}});
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.zoneWasCreated'),
          });
        }).finally(() => {
          this.loading = false;
          this.$store.dispatch('setLoader', false);
        });
      }

    },
    initZone() {
      const url = this.$store.getters.zones + this.$route.params.id;
      this.loadingData = true;
      this.axios.get(url).then(({data}) => {
        this.zone = data.Result;
        this.zoneName = data.Result.Name;
      }).finally(() => {
        this.loadingData = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>